import { render } from "./ModalSample.vue?vue&type=template&id=45cd3662&scoped=true"
import script from "./ModalSample.vue?vue&type=script&lang=js"
export * from "./ModalSample.vue?vue&type=script&lang=js"

import "./ModalSample.vue?vue&type=style&index=0&id=45cd3662&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cd3662"]])

export default __exports__